/* eslint react/prop-types: 0 */
import React from 'react'
// import CallApp from 'callapp-lib'

import {
  downLoadUrl,
  getAdjustDeeplink,
  appSchemeLink,
  downLoadUrlDic
} from '@kiss/utils/url'
import { getLocationVars, converUrlParamsObj, getEnv } from '@/utils/utils'
import { CustomDeeplinkParams } from '@kiss/typings/interfaces/bookShare'

import './index.scss'
import { clickGet } from '@/projects/kiss/utils/reportInfo/reportedMethods'

import defaultIcon from '@kiss/assets/logos/icon_mf.png'

interface IProps {
  appIcon?: string
  kissLinkData: any
  reportData?: any
  customParamsDic: CustomDeeplinkParams
  /** 上报参数 */
  reportParams?: any
}
/**
 * 打开kiss或跳转到App Store的footer
 */

// const isAdjustDeepLink = `${getLocationVars().isAdjustDeepLink}` === '1'

const ToKissFooter: React.FC<IProps> = ({
  appIcon,
  kissLinkData,
  reportData,
  customParamsDic,
  reportParams
}) => {
  // 判断是否有安装kiss，否则跳转到appstore
  const handlePushToKissOrAppStore = (isForTest: boolean | undefined) => {
    // 3.5上报
    reportParams &&
      clickGet({
        ...reportParams,
        parm9: location.href
      })

    // 因为修复不好 2秒后强制跳转到appstore的问题，直接利用adjustdeeplink进行跳转
    // if (isAdjustDeepLink) {
    if (!isForTest && reportData) reportData(2)
    const env = getEnv()
    if (env === 'prod' && isForTest) return
    const customParams = {
      ...customParamsDic
    }
    Object.keys(customParams).forEach((key: string) => {
      customParams[key] = kissLinkData[customParams[key]]
    })
    console.log(
      `${getAdjustDeeplink({ ...kissLinkData, isForTest, customParams })}`
    )
    window.location.href = `${getAdjustDeeplink({
      ...kissLinkData,
      isForTest,
      customParams
    })}`
    // }

    // const options = {
    //   scheme: { protocol: 'cmskiss', host: 'kiss' },
    //   appstore: downLoadUrlDic.appStore,
    //   fallback: downLoadUrl
    // }
    // const callLib = new CallApp(options)

    // callLib.open({
    //   path: converUrlParamsObj(kissLinkData)
    // })
    // return
    // window.location.href = `${appSchemeLink}?${converUrlParamsObj(kissLinkData)}`
    // setTimeout(() => {
    //   window.location.href = downLoadUrl
    //   window.location.href = downLoadUrl
    // }, 2000)
  }

  return (
    <div id='ToKissFooter-ctr'>
      <div
        className='ToKissFooter-kiss-logo'
        onClick={() => {
          handlePushToKissOrAppStore(true)
        }}
      >
        <img src={appIcon || defaultIcon} alt='' />
      </div>
      <div className='ToKissFooter-content'>
        <div>My Fiction</div>
        <div>Download now to read</div>
      </div>
      <div
        className='ToKissFooter-open-btn'
        onClick={() => handlePushToKissOrAppStore(false)}
      >
        OPEN
      </div>
    </div>
  )
}

export default ToKissFooter
